import TrailIndexPage from "lx/trailIndexPage";

export { TrailIndexPage };

customElements.define(
  "lx-trail-index-page",
  TrailIndexPage.CustomElementConstructor
);
